export class NotificationsService {
  iconColors = {
    info: "primary-500",
    success: "status-success-500",
    error: "status-critical-900",
    warning: "status-warning-800",
  };

  iconTemplates = {
    info: `<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>`,
    success: `<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                   <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                 </svg>`,
    error: `<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>`,
    warning: `<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>`,
  };

  async showNotification(title, description, icon, duration) {
    let iconTemplate = this.iconTemplates[icon];
    let iconColor = this.iconColors[icon];
    let notificationTemplate = ` 
        <div class="notification">
            <div class="notification__wrapper">
                <div class="notification__icon notification__icon--${icon}">
                    ${iconTemplate}
                </div>
                <div class="notification__body">
                    <p class="notification__body__title">
                        ${title}
                    </p>
                    <p class="notification__body__description">
                        ${description}
                    </p>
                </div>
                <div class="notification__close-button">
                    <button class="notification__close-button__button">
                        <span class="sr-only">Close</span>
                        <!-- Heroicon name: solid/x -->
                        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                        </svg>
                    </button>
                </div>
            </div>
        </div> `; 

    let notificationRegion = document.getElementById("notification-region");
    let notificationElement = document.createElement("div");
    notificationElement.setAttribute("class", "hidden max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden");
    notificationElement.setAttribute("data-transition-enter", "transform ease-out duration-300 transition");
    notificationElement.setAttribute("data-transition-enter-start", "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2");
    notificationElement.setAttribute("data-transition-enter-end", "translate-y-0 opacity-100 sm:translate-x-0");
    notificationElement.setAttribute("data-transition-leave", "transition ease-in duration-100");
    notificationElement.setAttribute("data-transition-leave-start", "opacity-100");
    notificationElement.setAttribute("data-transition-leave-end", "opacity-0");
    notificationElement.innerHTML = notificationTemplate;

    notificationRegion.appendChild(notificationElement);

    await window.transitions.enter(notificationElement);

    // close functionality
    setTimeout(async () => {
        await window.transitions.leave(notificationElement);
        notificationElement.remove();
    }, duration);

    let closeButton = notificationElement.querySelector(".notification__close-button__button");
    closeButton.addEventListener('click', async () => {
        await window.transitions.leave(notificationElement);
        notificationElement.remove();
    });
}
}
